import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { MousePointer2, Type, Timer, Table2 } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";

const MODES = [
  { id: 'click', icon: MousePointer2, label: 'Clicar', tip: 'Clica num elemento da captura de ecrã (botão, link, linha)' },
  { id: 'fill', icon: Type, label: 'Preencher', tip: 'Clica num campo na captura de ecrã e escreve o valor (email, palavra-passe, data…)' },
  { id: 'wait', icon: Timer, label: 'Esperar', tip: 'Insere uma pausa em milissegundos entre acções (útil para esperar pela página)' },
  { id: 'extract', icon: Table2, label: 'Extrair', tip: 'Clica numa célula da tabela final OU usa "Extrair tabela maior"' },
];

export default function ModeSwitcher({ mode, onChange, disabled }) {
  return (
    <TooltipProvider delayDuration={150}>
      <ToggleGroup type="single" value={mode} onValueChange={(v) => v && onChange(v)} disabled={disabled} data-testid="recorder-mode-switcher" className="bg-muted/60 rounded-lg p-1">
        {MODES.map(m => (
          <Tooltip key={m.id}>
            <TooltipTrigger asChild>
              <ToggleGroupItem value={m.id} data-testid={`mode-switcher-${m.id}`} className="h-9 px-3 gap-1.5 data-[state=on]:bg-card data-[state=on]:shadow-sm data-[state=on]:text-primary">
                <m.icon className="h-4 w-4"/>
                <span className="text-sm">{m.label}</span>
              </ToggleGroupItem>
            </TooltipTrigger>
            <TooltipContent>{m.tip}</TooltipContent>
          </Tooltip>
        ))}
      </ToggleGroup>
    </TooltipProvider>
  );
}
